module.exports = __webpack_public_path__ + "img/new2.278a3de5.png";